import React from 'react';
import UnifiedTopBar from '@frontend/Components/TopBar/UnifiedTopBar';
import { createDetailViewTemplate } from '@frontend/Components/TopBar/templates';
import './TransactionsTopbar.css';

interface TransactionsTopbarProps {
  setActivePage?: (page: string) => void;
}

const TransactionsTopbar: React.FC<TransactionsTopbarProps> = () => {
  const template = createDetailViewTemplate({});

  return <UnifiedTopBar {...template} />;
};

export default TransactionsTopbar;
